export const getTenantSlug = (): string => {
    const tenant_slug = window.location.hostname.split('.').slice(0, -2).join('.')
    const rootElement = document.getElementById('root');
    if (rootElement) {
        rootElement.setAttribute('data-tenant', tenant_slug);
    }
    return tenant_slug;
}